<div (keydown.enter)="submit()" class="flex flex-col gap-4">
  <div class="flex items-end gap-4">
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.nameFr" [label]="'local.french' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.nameNl" [label]="'local.dutch' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.nameEn" [label]="'local.english' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-numeric-input [control]="form.controls.rate" [label]="'tax.rate' | translate" suffix="%" [min]="0"
                           [max]="100"/>
    </div>
  </div>

  <div class="flex items-end gap-4">
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.peppolCode" [label]="'tax.peppol-code' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-numeric-input [control]="form.controls.deductibleVatPercentage" [label]="'tax.deductible-vat' | translate"
                           suffix="%" [min]="0" [max]="100"/>
    </div>
    <div class="flex-1">
      <elcia-check-box [control]="form.controls.isDefault" [label]="'tax.is-default' | translate"/>
    </div>
  </div>

  <div class="flex items-end gap-4 pt-2 border-t border-primary-50">
    <div class="flex-1">
      <elcia-accounting-account-dropdown [control]="form.controls.accountingAccountId"/>
    </div>
    <div class="w-32">
      <elcia-text-input [control]="form.controls.accountingCode" [label]="'tax.accounting-code' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-accounting-account-dropdown [control]="form.controls.accountingAccount2Id"/>
    </div>
    <div class="w-32">
      <elcia-text-input [control]="form.controls.accountingCode2" [label]="'tax.accounting-code-2' | translate"/>
    </div>
  </div>
</div>
